import { render, staticRenderFns } from "./personalservicelist.vue?vue&type=template&id=2ab0a3f3&scoped=true&"
import script from "./personalservicelist.vue?vue&type=script&lang=js&"
export * from "./personalservicelist.vue?vue&type=script&lang=js&"
import style0 from "./personalservicelist.vue?vue&type=style&index=0&id=2ab0a3f3&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab0a3f3",
  null
  
)

export default component.exports